var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTabContacts = function SvgTabContacts(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21 16.6",
    style: {
      enableBackground: "new 0 0 21 16.6"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Webphone_new_1",
    transform: "translate(-219.000000, -624.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy-2",
    transform: "translate(204.000000, 624.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(15.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.073600)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    fill: "#ACC0D2",
    d: "M19.7,7.6c0.8,0.9,1.3,2.1,1.3,3.2c0,0.4-0.1,0.8-0.4,1c-0.6,0.6-1.5,0.7-2.8,0.7 c-0.2,0-0.4,0-0.6,0c-0.2,0-0.3,0-0.5,0c-0.4,0-0.7-0.3-0.7-0.6c0,0,0,0,0,0c-0.6-2.1-2-3.6-2-3.6l0,0c0,0-0.1-0.1-0.1-0.1 c-0.2-0.4-0.2-0.9,0.2-1.2c0.1-0.1,0.3-0.2,0.4-0.3c-0.3-0.5-0.5-1-0.5-1.7c0-1.5,1.2-2.8,2.6-2.8c1.4,0,2.6,1.3,2.6,2.8 c0,0.6-0.2,1.2-0.5,1.7C18.9,6.9,19.3,7.2,19.7,7.6z M10,7.6c2.6,1.1,4.4,3.7,4.4,6.1c0,0.6-0.2,2.1-2.2,2.6 c-0.8,0.2-1.7,0.2-2.9,0.2c-0.2,0-0.5,0-0.7,0c-0.2,0-0.4,0-0.6,0c-0.3,0-0.5,0-0.8,0c-0.3,0-0.5,0-0.8,0c-0.2,0-0.4,0-0.6,0 c-0.3,0-0.5,0-0.7,0c-1.2,0-2.1,0-2.9-0.2c-2-0.5-2.2-2-2.2-2.6c0-2.4,1.8-5,4.4-6.1C3.5,6.8,3,5.6,3,4.3 c0-2.4,1.8-4.4,4.1-4.4c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c2.3,0,4.1,2,4.1,4.4C11.5,5.6,10.9,6.8,10,7.6z"
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTabContacts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tab_contacts.c26dc363.svg";
export { ForwardRef as ReactComponent };